import { render, staticRenderFns } from "./Lecture.vue?vue&type=template&id=66552119&"
import script from "./Lecture.vue?vue&type=script&lang=js&"
export * from "./Lecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports